import Utils from "../../services/Utils.js";

export function getGameTemplate (game) {
   if(!game.odd){
      return ''
   }

   let marketName;
   try {
      marketName = game.odd.split('|')[8] ?? 'Rezultat Final';
   } catch {
      marketName = 'Rezultat Final'
   }

   return `<div class="singleGameContent">
                 <a class="singleTeamNames" href="#/Match/${game.id}" data-id="${game.id}">
                     <div class="singleDateColumn">
                        <span>${Utils.formatDate(game.game_date, game.game_time, 'timeOnly')}</span>
                        <span class="numberofmarkets">${game.count_options} ></span>
                     </div>
                     <div class="singleDetailsColumn">
                       <div class="singleTeamRowLabel">
                         <span class="singleHomeName">${game.home_team}</span>
                         <span class="gameSingleHomeScore"></span>
                       </div>
                       <div class="singleTeamRowLabel">
                         <span class="singleAwayName">${game.away_team}</span>
                         <span class="gameSingleAwayScore"></span>
                       </div>
                     </div>
                 </a>
                 <div class="singleHomeOdd bettingBtn  ${Utils.formatNumber(game.odd.split(',')[0].split('|')[1]) == 1 ? 'disabledBtn' : '' } ${game.odd.split(',').length > 0 ? game.odd.split(',')[0].split('|')[0] : 'disabledBtn'}" 
                    
                       match-odd="${game.odd.split(',').length > 0 ? Utils.formatNumber(game.odd.split(',')[0].split('|')[1]) : ""}" 
                       match-home-name="${game.home_team}" 
                       match-away-name="${game.away_team}" 
                       match-market="${marketName}" 
                       match-market-option="1"
                       coef-id="${game.odd.split(',').length > 0 ? game.odd.split(',')[0].split('|')[0] : ""}" 
                       bet-id="${game.odd.split(',').length > 0 ? game.odd.split(',')[0].split('|')[0] : ""}" 
                       game-id="${game.id}"
                    >
                    ${game.odd.split(',').length > 0 ? Utils.formatNumber(game.odd.split(',')[0].split('|')[1]) : ""}
                 </div>
                 <div class="singleDrawOdd bettingBtn  ${Utils.formatNumber(game.odd.split(',')[1].split('|')[1]) == 1 ? 'disabledBtn' : '' } ${game.odd.split(',').length > 1 ? game.odd.split(',')[1].split('|')[0] : 'disabledBtn'}" 
                 
                    match-odd="${game.odd.split(',').length > 1 ? Utils.formatNumber(game.odd.split(',')[1].split('|')[1]) : ""}" 
                    match-home-name="${game.home_team}" 
                    match-away-name="${game.away_team}" 
                    match-market="${marketName}" 
                    match-market-option="X"
                    coef-id="${game.odd.split(',').length > 1 ? game.odd.split(',')[1].split('|')[0] : ""}" 
                    bet-id="${game.odd.split(',').length > 1 ? game.odd.split(',')[1].split('|')[0] : ""}" 
                    game-id="${game.id}"
                    
                    >
                     ${game.odd.split(',').length > 1 ? Utils.formatNumber(game.odd.split(',')[1].split('|')[1]) : ""}
                 </div>
                 ${game.odd.split(',').length == 3 && game.odd.split(',')[2].split('|').length > 1 ? `    <div class="singleAwayOdd bettingBtn  ${Utils.formatNumber(game.odd.split(',')[2].split('|')[1]) == 1 ? 'disabledBtn' : '' } ${game.odd.split(',').length > 2 ? game.odd.split(',')[2].split('|')[0] : 'disabledBtn'}" 

                 match-odd="${game.odd.split(',').length > 2 ? Utils.formatNumber(game.odd.split(',')[2].split('|')[1]) : ""}" 
                 match-home-name="${game.home_team}" 
                 match-away-name="${game.away_team}" 
                 match-market-option="2"
                 match-market="${marketName}" 
                 coef-id="${game.odd.split(',').length > 2 ? game.odd.split(',')[2].split('|')[0] : ""}" 
                 bet-id="${game.odd.split(',').length > 2 ? game.odd.split(',')[2].split('|')[0] : ""}" 
                 game-id="${game.id}"
              >
              ${game.odd.split(',').length > 2 ? Utils.formatNumber(game.odd.split(',')[2].split('|')[1]) : ""}
              </div>` : ``}
             
               </div>`;
}